import { Button, Popover } from "antd";
import { SortAscendingOutlined } from "@ant-design/icons";
import { useState } from "react";

interface Props {
    sortType: 'executada' | 'planejada' | 'precisao' | 'alfabetica';
    setSortType: (type: 'executada' | 'planejada' | 'precisao' | 'alfabetica') => void;
}

export const SortButton: React.FC<Props> = ({ sortType, setSortType }) => {
    const [open, setOpen] = useState(false);

    const handleSort = (type: 'executada' | 'planejada' | 'precisao' | 'alfabetica') => {
        setSortType(type);
        setOpen(false);
    };

    const content = (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 5 }}>
            <Button
                type={sortType === 'executada' ? 'primary' : 'text'}
                onClick={() => handleSort('executada')}
                style={{ textAlign: 'left' }}
                size="small"
            >
                Qtde Executada
            </Button>
            <Button
                type={sortType === 'planejada' ? 'primary' : 'text'}
                onClick={() => handleSort('planejada')}
                style={{ textAlign: 'left' }}
                size="small"
            >
                Qtde Planejada
            </Button>
            <Button
                type={sortType === 'precisao' ? 'primary' : 'text'}
                onClick={() => handleSort('precisao')}
                style={{ textAlign: 'left' }}
                size="small"
            >
                Precisão
            </Button>
            <Button
                type={sortType === 'alfabetica' ? 'primary' : 'text'}
                onClick={() => handleSort('alfabetica')}
                style={{ textAlign: 'left' }}
                size="small"
            >
                Alfabética
            </Button>
        </div>
    );

    return (
        <Popover
            content={content}
            title="Ordenar por"
            trigger="click"
            open={open}
            onOpenChange={setOpen}
        >
            <Button
                size="small"
                icon={<SortAscendingOutlined />}
                style={{ border: 'none', background: 'transparent', color: 'var(--text-color-light)', marginTop: -10 }}
            />
        </Popover>
    );
};
